export const state = {
    invoiceData: [],
    invoiceModal: false,
    modalActive: false,
    invoicesLoaded: false,
    currentInvoice: null,
    editInvoice: null
  }